export const loadonMapLeasing = async (routeAndSite, markers, map, setSelectedRoute, turf) => {
  let start = `${markers[0].lng},${markers[0].lat}`;
  let end = `${routeAndSite.site.Long},${routeAndSite.site.Lat}`;
  let site_id = routeAndSite.site.site_id;
  let obj = {
    start,
    end,
    site_id,
    geoJSON: routeAndSite.routeGeoJson,
    distance: turf.length(routeAndSite.routeGeoJson, { units: 'meters' }).toFixed(3),
  };
  setSelectedRoute(obj);
  if (map.current.getLayer('selected-route')) {
    map.current.removeLayer('selected-route');
    map.current.removeSource('selected-route');
  }

  // Add route source
  map.current.addSource(`selected-route`, {
    type: 'geojson',
    data: {
      type: 'Feature',
      geometry: routeAndSite.routeGeoJson,
    },
  });

  // // Add route layer for each alternate route with profile-specific color
  map.current.addLayer({
    id: `selected-route`,
    type: 'line',
    source: `selected-route`,
    layout: {
      'line-join': 'round',
      'line-cap': 'round',
    },
    paint: {
      'line-color': '#3887be', // Different color for each profile and route
      'line-width': 6,
      'line-opacity': 0.7,
    },
  });
};
